export { default } from "./chart2";


// WEBPACK FOOTER //
// ./src/components/chart2/index.js